import styled from "styled-components";

import { RiFullscreenFill, RiFullscreenExitLine } from "react-icons/ri";
import { PALETTE } from "@/styles/theme";

type FullScreenButtonProps = {
  isFullScreen: boolean;

  triggerFull: () => void;
  exitFull: () => void;
};

export const FullScreenButton = ({
  isFullScreen,
  triggerFull,
  exitFull
}: FullScreenButtonProps) => {
  const onClick = () => {
    if (isFullScreen) {
      exitFull();
    } else {
      triggerFull();
    }
  };
  return (
    <Wrapper>
      <Button onClick={onClick}>
        {isFullScreen ? (
          <RiFullscreenExitLine size={"1.3rem"} />
        ) : (
          <RiFullscreenFill size={"1.3rem"} />
        )}
      </Button>
    </Wrapper>
  );
};

export default FullScreenButton;

const Wrapper = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  cursor: auto;
`;

const Button = styled.button`
  background-color: ${PALETTE.white};
  color: #000;
  padding: 0.5rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;
